import { useLocation } from "@tanstack/react-router"
import { useCallback } from "react"

const KEY = "redirectAfterLogin"
const DEFAULT = "/dashboard"

const clearRedirectUrl = () => {
  sessionStorage.removeItem(KEY)
}

// Read the stored destination without consuming it, so a caller can decide
// whether an explicit redirect exists before computing a default. Guarded
// for SSR/prerender: /auth is a prerendered public route where there is no
// sessionStorage, and this runs during render (unlike getRedirectUrl).
const peekRedirectUrl = (): string | null =>
  typeof window === "undefined" ? null : sessionStorage.getItem(KEY)

const getRedirectUrl = (fallback: string = DEFAULT) => {
  const url = sessionStorage.getItem(KEY)
  if (!url) {
    return fallback
  }

  clearRedirectUrl()

  return url
}

export default () => {
  const href = useLocation({
    select: (location) => location.href,
  })

  const setRedirectUrl = useCallback(
    (customUrl?: string) => {
      if (!sessionStorage.getItem(KEY)) {
        sessionStorage.setItem(KEY, customUrl ?? href)
      }
    },
    [href],
  )

  return { getRedirectUrl, peekRedirectUrl, setRedirectUrl, clearRedirectUrl }
}
